
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/eigentuemer/immobilie-vermieten",
      function () {
        return require("private-next-pages/eigentuemer/immobilie-vermieten.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/eigentuemer/immobilie-vermieten"])
      });
    }
  